import React, { useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import EditIcon from "@mui/icons-material/Edit";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import FormHelperText from "@mui/material/FormHelperText";
import { makeStyles } from "@mui/styles";
import { Gap, MyButton, MyInput, MyAutocomplete } from "../../atoms";
import MyDialog from "../../molecules/Dialog";
import { PRIMARY } from "../../../utils/constansColors";
import AlertMessage from "../../../components/molecules/AlertMessage";
// import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import {
  getUsers,
  getDetailUser,
  updateUser,
  changePasswordUser,
  getHakAkses,
  updateHakAkses
} from "../../../config/Redux/UserManagement/actions";
import {
  getProvince,
  getKabKot,
  getKecamatan,
  getKelurahan,
  getKomisarisBasis,
} from "../../../config/Redux/Global/actions";
import { useDispatch, useSelector } from "react-redux";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '@mui/material/Tooltip';
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";

const validationSchemaPassword = yup.object().shape({
  katasandibaru: yup.string().required("Silahkan Masukan Kata Sandi Baru"),
  katasandibaruconfirm: yup
    .string()
    .required("Silahkan Konfirmasi Kata Sandi")
    .oneOf([yup.ref("katasandibaru"), null], "Kata Sandi tidak sama"),
});

const validationSchemaEdit = yup.object().shape({
  name: yup.string("Masukan Alamat").required("Silahkan Masukan Alamat"),
  phone: yup
    .string("Masukan Nomor Ponsel")
    .required("Silahkan Masukan Nomor Ponsel"),
  levelExco: yup
    .object()
    .shape({
      label: yup.string(),
      id: yup.string(),
    })
    .nullable()
    .required("Silahkan Masukan Tingkat Exco"),
  provinsi: yup
    .object()
    .when("levelExco", {
      is: (levelExco) =>
        (levelExco && levelExco?.id === "2") ||
        (levelExco && levelExco.id === "3") ||
        (levelExco && levelExco.id === "4"),
      then: yup
        .object()
        .shape({ label: yup.string(), id: yup.string() })
        .nullable()
        .required("Silahkan Masukan Provinsi"),
    })
    .nullable(),
  kabkot: yup
    .object()
    .when("levelExco", {
      is: (levelExco) =>
        (levelExco && levelExco?.id === "3") ||
        (levelExco && levelExco.id === "4"),
      then: yup
        .object()
        .shape({ label: yup.string(), id: yup.string() })
        .nullable()
        .required("Silahkan Masukan Kabupaten / Kota"),
    })
    .nullable(),
  kecamatan: yup
    .object()
    .when("levelExco", {
      is: (levelExco) => levelExco && levelExco?.id === "4",
      then: yup
        .object()
        .shape({ label: yup.string(), id: yup.string() })
        .nullable()
        .required("Silahkan Masukan Kecamatan"),
    })
    .nullable(),
  komisarisBasis: yup
    .object()
    .when("levelExco", {
      is: (levelExco) => levelExco && levelExco?.id === "7",
      then: yup
        .object()
        .shape({ label: yup.string(), id: yup.string() })
        .nullable()
        .required("Silahkan Masukan Komisaris Basis"),
    })
    .nullable(),
});

const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: PRIMARY,
      color: "white",
      border: "none",
    },
  },
  tableBody: {
    backgroundColor: "#FFFFFF",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    fontSize: "25px",
    borderRadius: 5,
  },
  tableHeader: {
    backgroundColor: "transparant",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    color: "#757575",
    fontWeight: 700,
  },
});

const columnData = [
  { no: 0, name: "No" },
  { no: 1, name: "Nama Lengkap" },
  { no: 2, name: "Email" },
  { no: 3, name: "Nomor Ponsel" },
  { no: 6, name: "Hak Akses" },
  { no: 4, name: "Tingkat EXCO" },
  { no: 5, name: "Daerah" },
];

const options = [
  { label: "EXCO Pusat", id: 1 },
  { label: "EXCO Provinsi", id: 2 },
  { label: "EXCO Kabupaten / Kota", id: 3 },
  { label: "EXCO Kecamatan", id: 4 },
  { label: "EXCO Kelurahan / Desa", id: 5 },
  { label: "EXCO Komisaris RT / RW", id: 6 },
  { label: "EXCO Komisaris Basis", id: 7 },
];

const BasicTable = ({ currentPage, search, sortBy, sortType, filterLevel, ...rest }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  // let navigate = useNavigate();
  // const [currentPage, setCurrentPage] = React.useState(1);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openDialogProfile, setOpenDialogProfile] = React.useState(false);
  const [openDialogHakAkses, setOpenDialogHakAkses] = React.useState(false);
  const [idUser, setIdUser] = React.useState(null);
  const [idProvinsi, setIdProvinsi] = React.useState(null);
  const [levelExco, setLevelExco] = React.useState(null);
  const [hakAkses, setHakAkses] = React.useState(null);

  const [showPasswordNew, setShowPasswordNew] = React.useState(false);
  const [showPasswordNewConfirm, setShowPasswordNewConfirm] =
    React.useState(false);

  // alertMessage
  const [openDialogAlert, setOpenDialogAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [status, setStatus] = React.useState(null);

  // selector
  const dataUsers = useSelector((state) => state.users.dataUsers);
  const dataDetailUser = useSelector((state) => state.users.dataDetailUser);
  const province = useSelector((state) => state.global.dataProvince);
  const kabkot = useSelector((state) => state.global.dataKabKot);
  const kecamatan = useSelector((state) => state.global.dataKecamatan);
  const komisarisBasis = useSelector((state) => state.global.dataKomisarisBasis);

  const dataHakAkses = useSelector((state) => state.users.dataHakAkses);
  // console.log(`dataDetailUser`, currentPage);

  // options
  let optionsProv = province?.data?.map((item) => ({
    label: item.nama_prov_kemdagri,
    id: item.kode_prov_bps,
  }));

  let optionsKabKot = kabkot?.data?.map((item) => ({
    label: item.nama_kab_kota_kemdagri,
    id: item.kode_kab_kota_bps,
  }));
  let optionsKecamatan = kecamatan?.data?.map((item) => ({
    label: item.nama_kec_bps,
    id: item.kode_kec_bps,
  }));

  let optionsKomisarisBasis = komisarisBasis?.data?.map((item) => ({
    label: item.tingkat_puk_industri,
    id: item.tingkat_puk_industri,
  }));

  // change password
  const handleOpenDialog = (id) => {
    setIdUser(id);
    setOpenDialog(true);
    formik.resetForm();
  };

  const handleCloseDialog = () => {
    formik.resetForm();
    setOpenDialog(false);
  };

  // edit profile
  const handleOpenDialogProfile = (item) => {
    const { id_user, id_tingkat_exco } = item;
    setOpenDialogProfile(true);
    setIdUser(id_user);
    setLevelExco(id_tingkat_exco);
    dispatch(getDetailUser(id_user));
    if (id_tingkat_exco === 7) {
      dispatch(getKomisarisBasis());
    }
    formikProfile.resetForm();
  };

  const handleCloseDialogProfile = () => {
    setOpenDialogProfile(false);
  };

  const handleClickShowPassword = (param) => {
    if (param === "newPass") {
      setShowPasswordNew(!showPasswordNew);
    }
    if (param === "passNewConfirm") {
      setShowPasswordNewConfirm(!showPasswordNewConfirm);
    }
  };

  // formik change password
  const formik = useFormik({
    initialValues: {
      katasandibaru: "",
      katasandibaruconfirm: "",
    },
    enableReinitialize: false,
    validationSchema: validationSchemaPassword,
    onSubmit: async (values) => {
      let payload = {
        newPassword: values.katasandibaru,
        id: idUser,
      };
      let resp = await dispatch(changePasswordUser(payload));

      if (resp.type === "CHANGE_PASSWORD_USER_SUCCESS") {
        setMessage(resp.payload.message);
        setOpenDialogAlert(true);
        setStatus("");
        handleCloseDialog();
      } else {
        setMessage(resp.payload.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    },
  });

  let dataDetail = dataDetailUser.data && dataDetailUser.data[0];

  // formik edit data profile
  const formikProfile = useFormik({
    initialValues: {
      name: dataDetail?.nama,
      phone: dataDetail?.noHandphone,
      levelExco: dataDetail?.id_tingkat_exco
        ? {
            id: dataDetail?.id_tingkat_exco,
            label: dataDetail?.nama_tingkat_exco,
          }
        : null,
      provinsi: dataDetail?.id_provinsi
        ? {
            id: dataDetail?.id_provinsi,
            label: dataDetail?.nama_provinsi,
          }
        : null,
      kabkot: dataDetail?.id_kabkot
        ? {
            id: dataDetail?.id_kabkot,
            label: dataDetail?.nama_kabkot,
          }
        : null,
      kecamatan: dataDetail?.id_kecamatan
        ? {
            id: dataDetail?.id_kecamatan,
            label: dataDetail?.nama_kecamatan,
          }
        : null,
      komisarisBasis: dataDetail?.id_komisaris_basis
        ? {
            id: dataDetail?.id_komisaris_basis,
            label: dataDetail?.nama_komisaris_basis,
          }
        : null,
    },
    enableReinitialize: true,
    validationSchema: validationSchemaEdit,
    onSubmit: async (values) => {
      let data = values;
      const payload = {
        name: data.name,
        phone: data.phone,
        id_tingkat_exco: data?.levelExco?.id,
        id_provinsi: data?.provinsi?.id || null,
        id_kabkot: data?.kabkot?.id || null,
        id_kecamatan: data?.kecamatan?.id || null,
        tingkat_puk_industri: data?.komisarisBasis?.id || null,
      };
      let resp = await dispatch(updateUser(idUser, payload));
      if (resp.type === "PUT_USERS_SUCCESS") {
        handleCloseDialogProfile();
        dispatch(getUsers(currentPage, search, sortBy, sortType, filterLevel));
        setMessage(resp.payload.message);
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    },
  });

  // form Ubah data
  const renderFormProfile = (
    <>
      <div align="center">
        <h2>
          <b>Ubah Data</b>
        </h2>
      </div>
      <MyInput
        id="name"
        name="name"
        label="Nama Pengguna"
        fullWidth
        size="medium"
        value={formikProfile.values.name || ""}
        onChange={formikProfile.handleChange}
        error={formikProfile.touched.name && Boolean(formikProfile.errors.name)}
        helperText={formikProfile.touched.name && formikProfile.errors.name}
      />
      <Gap height={20} />

      <MyInput
        id="phone"
        name="phone"
        label="Nomor Ponsel"
        fullWidth
        size="medium"
        value={formikProfile.values.phone || ""}
        onChange={formikProfile.handleChange}
        error={
          formikProfile.touched.phone && Boolean(formikProfile.errors.phone)
        }
        helperText={formikProfile.touched.phone && formikProfile.errors.phone}
      />
      <Gap height={20} />
      <MyAutocomplete
        options={options}
        fullWidth
        size="medium"
        label="Tingkat Exco*"
        id="levelExco"
        name="levelExco"
        value={formikProfile.values.levelExco || null}
        onChange={(e, value) => {
          formikProfile.setFieldValue("levelExco", value);
          setLevelExco(value.id);
          if (value.id === 7) {
            dispatch(getKomisarisBasis());
          }
        }}
      />
      <FormHelperText id="component-error-text" style={{ color: "red" }}>
        {formikProfile.touched.levelExco && formikProfile.errors.levelExco}
      </FormHelperText>
      <Gap height={20} />

      {/* select provinsi */}
      {(levelExco === 2 || levelExco === 3 || levelExco === 4) && (
        <>
          <MyAutocomplete
            id="provinsi"
            name="provinsi"
            fullWidth
            options={optionsProv || []}
            // handleChange={(e, value) => formik.setFieldValue("provinsi", value)}
            size="medium"
            label="Provinsi"
            renderInput={(params) => <MyInput {...params} label="Provinsi" />}
            value={formikProfile.values.provinsi || null}
            onChange={(e, value) => {
              dispatch(getKabKot(value.id));
              setIdProvinsi(value.id);
              formikProfile.setFieldValue("provinsi", value);
            }}
          />
          <FormHelperText id="component-error-text" style={{ color: "red" }}>
            {formikProfile.touched.provinsi && formikProfile.errors.provinsi}
          </FormHelperText>
          <Gap height={10} />
        </>
      )}

      {/* select kabupaten / kota */}

      {(levelExco === 3 || levelExco === 4) && (
        <>
          <MyAutocomplete
            fullWidth
            size="medium"
            label="Kabupaten / Kota*"
            options={optionsKabKot || []}
            id="kabkot"
            name="kabkot"
            value={formikProfile.values.kabkot || null}
            // handleChange={(e, value) => formikProfile.setFieldValue("kabkot", value)}
            onChange={(e, value) => {
              dispatch(
                getKecamatan(`provinsi=${idProvinsi}&kotaKab=${value.id}`)
              );
              formikProfile.setFieldValue("kabkot", value);
            }}
          />
          <FormHelperText id="component-error-text" style={{ color: "red" }}>
            {formikProfile.touched.kabkot && formikProfile.errors.kabkot}
          </FormHelperText>
          <Gap height={10} />
        </>
      )}

      {/* select kecamatan */}

      {levelExco === 4 && (
        <>
          <MyAutocomplete
            fullWidth
            size="medium"
            label="Kecamatan"
            id="kecamatan"
            options={optionsKecamatan || []}
            name="kecamatan"
            value={formikProfile.values.kecamatan || null}
            onChange={(e, value) => {
              dispatch(getKelurahan(`kecamatan=${value.id}`));
              formikProfile.setFieldValue("kecamatan", value);
            }}
          />
          <FormHelperText id="component-error-text" style={{ color: "red" }}>
            {formikProfile.touched.kecamatan && formikProfile.errors.kecamatan}
          </FormHelperText>
          <Gap height={10} />
        </>
      )}

      {/* select komisaris basis */}
      {levelExco === 7 && (
        <>
          <MyAutocomplete
            fullWidth
            size="medium"
            label="Komisaris Basis*"
            id="komisarisBasis"
            options={optionsKomisarisBasis || []}
            name="komisarisBasis"
            value={formikProfile.values.komisarisBasis || null}
            onChange={(e, value) => {
              formikProfile.setFieldValue("komisarisBasis", value);
            }}
          />
          <FormHelperText id="component-error-text" style={{ color: "red" }}>
            {formikProfile.touched.komisarisBasis && formikProfile.errors.komisarisBasis}
          </FormHelperText>
          <Gap height={10} />
        </>
      )}

      <div style={{ display: "flex" }}>
        <MyButton
          height="40px"
          color="#B9B9B9"
          fullWidth
          backgroundColor="#FFFFFFFF"
          borderColor="#B9B9B9"
          backgroundColorHover="#FFFFFFFF"
          variant="outlined"
          children="Batal"
          onClick={handleCloseDialogProfile}
        />
        <Gap width={30} />
        <MyButton
          height="40px"
          color="#8B8B8B"
          colorHover="white"
          fullWidth
          backgroundColor="#E8E8E8"
          borderColor="#E8E8E8"
          backgroundColorHover="#F06524"
          variant="outlined"
          children="Simpan"
          type="submit"
          onClick={formikProfile.handleSubmit}
        />
      </div>
    </>
  );

  // change password
  const renderFormPassword = (
    <>
      <div align="center">
        <h2>
          <b>Ubah Kata Sandi</b>
        </h2>
        <Gap height={20} />

        <MyInput
          id="katasandibaru"
          name="katasandibaru"
          label="Kata Sandi Baru*"
          fullWidth
          size="medium"
          value={formik.values.katasandibaru}
          onChange={formik.handleChange}
          error={
            formik.touched.katasandibaru && Boolean(formik.errors.katasandibaru)
          }
          helperText={
            formik.touched.katasandibaru && formik.errors.katasandibaru
          }
          type={showPasswordNew ? "text" : "password"}
          InputProps={{
            // <-- This is where the toggle button is added.
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => handleClickShowPassword("newPass")}
                  // onMouseDown={handleMouseDownPassword}
                >
                  {showPasswordNew ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Gap height={20} />
        <MyInput
          id="katasandibaruconfirm"
          name="katasandibaruconfirm"
          label="Kata Sandi Baru Konfirmasi*"
          fullWidth
          size="medium"
          value={formik.values.katasandibaruconfirm}
          onChange={formik.handleChange}
          error={
            formik.touched.katasandibaruconfirm &&
            Boolean(formik.errors.katasandibaruconfirm)
          }
          helperText={
            formik.touched.katasandibaruconfirm &&
            formik.errors.katasandibaruconfirm
          }
          type={showPasswordNewConfirm ? "text" : "password"}
          InputProps={{
            // <-- This is where the toggle button is added.
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => handleClickShowPassword("passNewConfirm")}
                  // onMouseDown={handleMouseDownPassword}
                >
                  {showPasswordNewConfirm ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Gap height={20} />
        <div style={{ display: "flex" }}>
          <MyButton
            height="40px"
            color="#B9B9B9"
            fullWidth
            backgroundColor="#FFFFFFFF"
            borderColor="#B9B9B9"
            backgroundColorHover="#FFFFFFFF"
            variant="outlined"
            children="Batal"
            onClick={handleCloseDialog}
          />
          <Gap width={30} />
          <MyButton
            height="40px"
            color="#8B8B8B"
            colorHover="white"
            fullWidth
            backgroundColor="#E8E8E8"
            borderColor="#E8E8E8"
            backgroundColorHover="#F06524"
            variant="outlined"
            children="Simpan"
            type="submit"
            onClick={formik.handleSubmit}
          />
        </div>
      </div>
    </>
  );

  // edit hak akses
  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  const handleOpenDialogHakAkses = (item) => {
    const { id_user, hak_akses } = item;
    let generateHakAkses = [];
    dataHakAkses?.data?.map((list,idx)=>{
      generateHakAkses[idx] = {
        id_user:id_user,
        id:list.id,
        tipe_hak_akses:list.tipe_hak_akses,
        deskripsi:list.deskripsi,
        value:false
      }
      hak_akses?.map((list2)=>{
        if(list.tipe_hak_akses === list2.hak_akses){
          generateHakAkses[idx].value = true
        }
      })
    })
    setOpenDialogHakAkses(true);
    setHakAkses(generateHakAkses)
  };
  const handleCloseDialogHakAkses = () => {
    setOpenDialogHakAkses(false);
  };
  const handleChangeHakAkses = async (event,id_user) =>{
    let payload = {
      id_user: id_user,
      id_tipe_hak_akses: event.target.name
    }
    let resp = await dispatch(updateHakAkses(payload));
    if(resp){
      dispatch(getUsers(currentPage, search, sortBy, sortType, filterLevel));
      let temp = hakAkses;
      temp?.map((list,idx)=>{
        if(list.id === parseInt(event.target.name)){
          temp[idx].value = !temp[idx].value
        }
      })
      setHakAkses(temp)
    }
  }

  // change hak akses
  const renderFormHakAkses = (
    <>
      <div align="center">
        <h2>
          <b>Ubah Hak Akses</b>
        </h2>
        <Gap height={20} />
        {hakAkses?.map((list,idx)=>{
          return(
            <div style={{textAlign:'left'}}>
              <Tooltip title={list.deskripsi}>
                <FormControlLabel
                  key={idx}
                  control={
                    <Checkbox checked={list.value} onChange={(e)=>handleChangeHakAkses(e,list.id_user)} name={list.id} />
                  }
                  label={list.tipe_hak_akses}
                />
              </Tooltip>
            </div>
          )
        })}
        
        <Gap height={20} />
        <div style={{ display: "flex" }}>
          <MyButton
            height="40px"
            color="#8B8B8B"
            colorHover="white"
            fullWidth
            backgroundColor="#E8E8E8"
            borderColor="#E8E8E8"
            backgroundColorHover="#F06524"
            variant="outlined"
            children="Selesai"
            onClick={handleCloseDialogHakAkses}
          />
        </div>
      </div>
    </>
  );

  useEffect(() => {
    dispatch(getProvince());
    dispatch(getHakAkses());
  }, [dispatch]);

  // When dataDetailUser changes (after opening edit dialog), fetch dependent dropdowns
  useEffect(() => {
    if (dataDetail && openDialogProfile) {
      // Update levelExco state to show/hide the right dropdowns
      if (dataDetail.id_tingkat_exco) {
        setLevelExco(dataDetail.id_tingkat_exco);
      }
      // Fetch kabkot options if user has a province
      if (dataDetail.id_provinsi) {
        setIdProvinsi(dataDetail.id_provinsi);
        dispatch(getKabKot(dataDetail.id_provinsi));
      }
      // Fetch kecamatan options if user has a kabkot
      if (dataDetail.id_provinsi && dataDetail.id_kabkot) {
        dispatch(
          getKecamatan(
            `provinsi=${dataDetail.id_provinsi},kotaKab=${dataDetail.id_kabkot}`
          )
        );
      }
    }
  }, [dataDetail, openDialogProfile, dispatch]);

  return (
    <>
      {/* change password */}
      <MyDialog
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        renderValue={renderFormPassword}
        fullWidth={true}
        maxWidth={"sm"}
      />
      {/* change hak akses */}
      <MyDialog
        openDialog={openDialogHakAkses}
        handleCloseDialog={handleCloseDialogHakAkses}
        renderValue={renderFormHakAkses}
        fullWidth={true}
        maxWidth={"sm"}
      />
      {/* edit user */}
      <MyDialog
        openDialog={openDialogProfile}
        handleCloseDialog={handleCloseDialogProfile}
        renderValue={renderFormProfile}
        fullWidth={true}
        maxWidth={"sm"}
      />
      {/* alertMessage */}
      <AlertMessage
        openDialog={openDialogAlert}
        message={message}
        status={status}
        handleCloseDialog={() => setOpenDialogAlert(false)}
      />

      <TableContainer>
        <Table
          sx={{ minWidth: 650 }}
          aria-label="simple table"
          className={classes.tableHeader}
        >
          <TableHead>
            <TableRow>
              {columnData.map((item, key) => {
                return (
                  <TableCell
                    key={key}
                    style={{
                      fontWeight: 700,
                      color: "#757575",
                      width:
                        item.name === "No"
                          ? "3%"
                          : item.name === "Daerah"
                          ? ""
                          : "10%",
                    }}
                  >
                    {item.name}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        </Table>
        {dataUsers?.data?.data?.map((item, index) => {
          let number = index + 1 + 10 * (dataUsers?.data?.current_page - 1);
          if(profile?.data?.id === item.id_user){
            return null
          } else {
          return (
            <Table
              sx={{ minWidth: 650 }}
              aria-label="simple table"
              className={classes.tableBody}
            >
              <TableBody>
                <TableRow key={item.id}>
                  <TableCell width="3%">{number}</TableCell>
                  <TableCell width="10%">
                    <div style={{ wordWrap: "break-word" }}>
                      {item.nama || "-"}
                    </div>
                  </TableCell>
                  <TableCell width="10%">
                    <div style={{ wordWrap: "break-word" }}>
                      {item.email || "-"}
                    </div>
                  </TableCell>
                  <TableCell width="10%">
                    <div style={{ wordWrap: "break-word" }}>
                      {item.noHandphone || "-"}
                    </div>
                  </TableCell>
                  <TableCell width="10%">
                    <ul style={{paddingInlineStart:'0px'}}>
                    {item?.hak_akses.map((list,idx)=>{
                      return (<li key={idx} style={{fontSize:'10px'}}>{list?.hak_akses}</li>)
                    })}
                    </ul>
                  </TableCell>
                  <TableCell width="10%">
                    {item.nama_tingkat_exco || "-"}
                  </TableCell>
                  <TableCell>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p style={{ marginTop: 10, fontSize: "12px" }}>
                        <span
                          style={{ color: "#757575" }}
                        >{` Provinsi: `}</span>
                        <span style={{ fontWeight: "bold" }}>{`${
                          item.nama_provinsi || "-"
                        }`}</span>
                        <br />
                        <span
                          style={{ color: "#757575" }}
                        >{` Kab / Kot: `}</span>
                        <span style={{ fontWeight: "bold" }}>{`${
                          item.nama_kabkot || "-"
                        }`}</span>
                        <br />
                        <span
                          style={{ color: "#757575" }}
                        >{` Kecamatan: `}</span>
                        <span style={{ fontWeight: "bold" }}>{`${
                          item.nama_kecamatan || "-"
                        }`}</span>
                      </p>
                      <Gap width={30} />
                      <div>
                        <MyButton
                          startIcon={<EditIcon />}
                          style={{ marginTop: 5 }}
                          color="white"
                          // height={"100%"}
                          size="small"
                          backgroundColor="#f06524"
                          borderColor="#f06524"
                          backgroundColorHover="#f06524"
                          variant="outlined"
                          children="Ubah Data"
                          onClick={() => handleOpenDialogProfile(item)}
                        />
                        <Gap width={10} />
                        <MyButton
                          startIcon={<EditIcon />}
                          style={{ marginTop: 5 }}
                          color="white"
                          // height={"100%"}
                          size="small"
                          backgroundColor="#FF9000"
                          borderColor="#FF9000"
                          backgroundColorHover="#FF9000"
                          variant="outlined"
                          children="Ubah Hak Akses"
                          onClick={() => handleOpenDialogHakAkses(item)}
                        />
                        <Gap width={10} />
                        <MyButton
                          startIcon={<EditIcon />}
                          style={{ marginTop: 5 }}
                          color="#F06524"
                          colorHover="#F06524"
                          // height={"100%"}
                          size="small"
                          backgroundColor={"#FFFFFF"}
                          borderColor={"#F06524"}
                          backgroundColorHover={"#FFFFFF"}
                          variant="outlined"
                          children="Ubah Kata Sandi"
                          onClick={() => handleOpenDialog(item.id_user)}
                        />
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          );
          }
        })}
      </TableContainer>
      {/* <div
        style={{
          justifyContent: "flex-end",
          display: "flex",
          marginTop: "10px",
        }}
      >
        <Pagination
          count={dataUsers?.data?.total_pages}
          variant="outlined"
          shape="rounded"
          page={currentPage}
          onChange={handlePagination}
          className={classes.root}
        />
      </div>
      <Gap height={20} /> */}
    </>
  );
}

export default BasicTable;